import { gql } from '@apollo/client'

export const MODIFY_ROOMTYPE_FACILITIES_MUTATION = gql`
  mutation SaveRoomTypeFacilities(
    $selectedIDs: [String!]!
    $propertyCode: String!
    $roomTypeCode: String!
  ) {
    saveRoomTypeFacilities(
      selectedIDs: $selectedIDs
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
    ) {
      message
    }
  }
`
